export enum StorageType {
    OFFICE = 'Office',
    MULTIVERZUM_WAREHOUSE = 'Warehouse',
    PARTNER_WAREHOUSE = 'PartnerWarehouse',
    PRESS = 'Press',
    FESTIVAL = 'Festival'
}

export const storageTypeFilterByKey: Record<string, StorageType> = Object.keys(StorageType).reduce(
    (acc, key) => {
        acc[key] = StorageType[key as keyof typeof StorageType];
        return acc;
    },
    {} as Record<string, StorageType>
);

export function getStorageTypeEnumKeys(): (keyof typeof StorageType)[] {
    return Object.keys(StorageType).filter((key) => isNaN(Number(key))) as (keyof typeof StorageType)[];
}

export function getStorageTypeByKey(key: string): string | null {
    if (key in StorageType) {
        return StorageType[key as keyof typeof StorageType];
    }
    return null;
}

export function getStorageTypeByValue(value: string): string | null {
    const result = Object.keys(StorageType).find((key) => StorageType[key as keyof typeof StorageType] === value);
    return result ?? null;
}

export function getStorageTypeDisplayValue(enumMember: StorageType | undefined): string | null {
    if (enumMember) {
        return getStorageTypeByKey(enumMember);
    }
    return 'EmptyValue';
}
